"use strict";

import "core-js/modules/web.dom-collections.iterator.js";
import { RemixPage } from "~/utils/remix-page";
import { cssLinks } from "@ttark/css-links";
import { UserFollowHead } from "./head";
import { UserFollowBody } from "./body";
import { buildMasterLoader } from "~/utils/build-master-loader";
var links = () => [...cssLinks("routes/$user_link_name_.follow")];
var loader = buildMasterLoader("userFollow");
var shouldRevalidate = args => {
  const {
    currentParams: {
      user_link_name: currentUserLinkName
    },
    nextParams: {
      user_link_name: userLinkName
    },
    defaultShouldRevalidate
  } = args;
  if (currentUserLinkName === userLinkName) {
    console.log("[shouldRevalidate] same route, skip revalidate");
    return false;
  }
  return defaultShouldRevalidate;
};
var UserFollowPage = class extends RemixPage {
  constructor() {
    super(...arguments);
    this.Head = UserFollowHead;
    this.Body = UserFollowBody;
  }
};
export { UserFollowPage as default, links, shouldRevalidate };